import React from 'react'
import { useTranslation } from 'react-i18next'
import ListActionBar from '../../../Blocks/Controls/ListActionBar/ListActionBar.jsx'
import { default as CommonPopup } from '../../../../../../../common/components/Popup/Popup.jsx'
import { IconDetails } from '../../../../../../../svg'

import './Popup.scss'

const Popup = ({ index, arrayLength, methods }) => {
    const { t } = useTranslation()

    const isFirst = index === 0

    return (
        <CommonPopup
            className="internal-pages-popup"
            actionHtml={<IconDetails />}
            popupHtml={
                <div className="internal-pages-popup__details-box">
                    <div className="internal-pages-popup__details">
                        {!isFirst ? (
                            <>
                                <li
                                    className="internal-pages-popup__detail"
                                    data-icon="rename"
                                    onClick={methods.onClickRename}
                                >
                                    {t('Rename')}
                                </li>
                                <ListActionBar
                                    className="internal-pages-popup__details"
                                    index={index}
                                    length={arrayLength}
                                    upMinIndex={1}
                                    isShowLabel
                                    onChangePosition={methods.onChangePosition}
                                    onClone={methods.onClone}
                                    onRemove={methods.onRemove}
                                />
                            </>
                        ) : (
                            <li className="internal-pages-popup__detail" data-icon="clone" onClick={methods.onClone}>
                                {t('Clone')}
                            </li>
                        )}
                    </div>
                </div>
            }
        />
    )
}
export default Popup
